import { RuleId, RuleLevel } from '../../../types-v2';
export const skipToMainContentRule = {
  checker: _ref => {
    let {
      skipToMainContentEnabled
    } = _ref;
    return {
      status: skipToMainContentEnabled ? 'passed' : 'failed'
    };
  },
  level: RuleLevel.Site,
  ruleId: RuleId.SKIP_TO_MAIN_CONTENT
};
//# sourceMappingURL=skip-to-main-content.js.map